<script>
export default {
  components: {},
  props: {
    isButton: {
      type: Boolean,
      required: false,
    },
    placeholderId: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data() {
    return {};
  },
  computed: {
    placeholderTitle() {
      return `Client ${this.placeholderId?.substring(3)}`;
    },
  },
  methods: {
    importProspects() {
      this.$bvModal.show('import-wizard-modal');
    },
  },
};
</script>

<template>
  <div
    :class="['card-prospect-placeholder', { 'is-button': isButton }]"
    @click.stop="importProspects"
  >
    <div class="btn-add">
      <BaseIcon class="icon-plus" name="plus" v-if="isButton" />
    </div>
    <div class="card-prospect-title">
      <span v-if="isButton">Add More Leads</span>
      <span v-else>{{ placeholderTitle }}</span>
    </div>
    <div class="card-actions" v-if="!isButton">
      <BaseIcon name="ellipsis-h" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-prospect-placeholder {
  background-color: white;
  border: 1px dashed $color-light-gray-three;
  border-radius: $base-border-radius-md;
  color: $color-light-gray-seven;
  display: flex;
  height: 8.8rem;
  margin: 0 0.8rem 0.8rem 0;
  padding: 0.8rem;
  transition: transform $duration-animation-base ease-out,
    opacity $duration-animation-base + 200 ease-out;
  width: 68.8rem;

  .btn-add {
    align-items: center;
    background-color: $color-off-white-one;
    border-radius: $base-border-radius-md;
    display: flex;
    height: 7.2rem;
    justify-content: center;
    margin-right: 1.3rem;
    width: 7.2rem;

    .icon-plus {
      font-size: 1.4rem;
    }
  }

  .card-prospect-title {
    align-items: center;
    color: $color-medium-gray-one;
    display: flex;
    flex: 1.6;
    font-size: 1.8rem;
    font-weight: bold;
    letter-spacing: -0.257143px;
    line-height: 2.4rem;
  }

  &:hover {
    cursor: default;
  }

  .card-actions {
    align-items: center;
    display: flex;
    position: relative;
    right: 1.6rem;

    .fa-ellipsis-h {
      color: $color-light-gray-three;
      font-size: 1.8rem;

      &:hover {
        cursor: pointer;
      }
    }
  }

  &.is-button {
    border: 1px solid $color-light-gray-four;

    &:hover {
      cursor: pointer;
      transform: scale(1.01);
    }

    .btn-add {
      background-color: white;
      border: 1px solid $color-light-gray-four;
      color: $color-primary;
    }

    .card-prospect-title {
      color: $color-primary;
      visibility: visible;
    }
  }
}
</style>
